module.exports = __webpack_public_path__ + "media/images/features/report-screenshot-12372f76144886504f8807751344c66a.png";